var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Generated by `npm run icon`, don't modify this file
import React from 'react';
import Base from './_base';
const Search = props => {
    const { className = null } = props, other = __rest(props, ["className"]);
    return (<Base viewBox="0 0 16 16" className={`cuk2-icon-search ${className}`} {...other}>
      <g>
        <path d="M7 1a6 6 0 014.714 9.713l2.932 2.933a.5.5 0 010 .708l-.353.353a.5.5 0 01-.707 0l-2.94-2.94A6 6 0 117 1zm0 1.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9z" fillRule="evenodd"/>
      </g>
    </Base>);
};
export default Search;
